import {useState} from 'react'
import {AppleLoginButton} from './AppleLoginButton'
import {GoogleLoginButton} from './GoogleLoginButton'
import {SsoButtonTemplate} from './SsoButtonTemplate'
import {config} from '../config'
import {
  OAuthProvider,
  Platform,
  getOAuthState,
  localesToLanguageCode,
  toQueryParameters
} from 'notability-services-common-universal'
import {logFathomEvent, useThemedStylesWithBreaks} from 'notability-services-common-frontend'
import {useSearchParams} from 'next/navigation'
import {loginErrorParam} from '../util/constants'
import {loginStyles} from './LoginStyles'
import {useIsWebAppUser} from '../hooks/useIsWebAppUser'

export function SingleSignOn() {
  const searchParams = useSearchParams()
  const redirectedWithError = searchParams.get(loginErrorParam) === 'true'
  const s = useThemedStylesWithBreaks(loginStyles)

  const isFromWebApp = useIsWebAppUser()

  const handleMsalRedirect = () => {
    logFathomEvent('SSO Open - Microsoft')
    const params = toQueryParameters(
      getOAuthState(Platform.WEB, OAuthProvider.MICROSOFT, localesToLanguageCode(navigator.languages), isFromWebApp)
    )

    window.location.assign(`${config.API_SERVICE_URL}/microsoft/auth-url?${params}`)
  }

  const [showOAuthError, setShowOAuthError] = useState(redirectedWithError)

  return (
    <div style={s.hStack}>
      {showOAuthError && <p style={s.errorText}>{'The sign in method did not work. Please try again.'}</p>}

      <GoogleLoginButton setShowOAuthError={setShowOAuthError} isFromWebApp={isFromWebApp} />
      <AppleLoginButton setShowOAuthError={setShowOAuthError} isFromWebApp={isFromWebApp} />
      <SsoButtonTemplate provider={OAuthProvider.MICROSOFT} onClick={handleMsalRedirect} />
    </div>
  )
}
